import React, { useState } from 'react'

function CreatePreview(props) {
  const { checkDisabled, handleCreateOrUpdateDynamicList, mode, PreviewData } = props
  const [buttonClicked, setButtonClicked] = useState(false) // State to track button click

  const listname = mode === 'create' ? 'Create Dynamic List' : 'Update Dynamic List'

  const handleClick = () => {
    // Disable button when clicked
    setButtonClicked(true)
    // Call the provided function
    handleCreateOrUpdateDynamicList()
  }

  return (
    <div className='d-flex gap-3 my-3'>
      <button
        className='btn btn-primary'
        disabled={!checkDisabled || buttonClicked} // Disable button if checkDisabled is false or button is clicked
        onClick={handleClick}
      >
        {listname}
      </button>
      <button className='btn btn-primary' disabled={!checkDisabled} onClick={PreviewData}>
        Preview
      </button>
    </div>
  )
}

export default CreatePreview
